import { SVGProps } from 'react';

const SearchRangeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={21}
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m6.667 13.833 1.666-5 5-1.666-1.666 5-5 1.666Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2.5 10.5a7.5 7.5 0 1 0 15 0 7.5 7.5 0 0 0-15 0Z"
    />
  </svg>
);

export default SearchRangeIcon;
